var __jsx = React.createElement;
import React from 'react';
function EditeIcon(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    className: className,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H26C28.2091 0 30 1.79086 30 4V26C30 28.2091 28.2091 30 26 30H4C1.79086 30 0 28.2091 0 26V4Z",
    fill: "#3C56D4"
  }), /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_165_4261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6489 9.57969L16.4212 10.8074L20.1919 14.5781L21.4196 13.3504C21.7915 12.9813 21.9993 12.4781 21.9993 11.9531C21.9993 11.4281 21.7915 10.925 21.4196 10.5559L20.4434 9.57969C20.0743 9.20781 19.5712 9 19.0462 9C18.5212 9 18.018 9.20781 17.6489 9.57969ZM15.4942 11.7344L9.60983 17.616C9.31725 17.9086 9.10397 18.275 8.99186 18.6742L8.02389 22.1687C7.961 22.3957 8.02389 22.6418 8.19342 22.8086C8.36295 22.9754 8.60631 23.041 8.83327 22.9781L12.3278 22.0074C12.727 21.8953 13.0907 21.6848 13.386 21.3895L19.2649 15.5051L15.4942 11.7344Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_4261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "14",
    height: "14",
    fill: "white",
    transform: "translate(8 9)"
  }))));
}
export default EditeIcon;